import { createResourceCollection } from '@/request'
import { ChargerActiveChargeSettings } from '@/types/activeChargeSettings'

/**
 * Client for `GET /api/active_charge_settings/charger/<charger_id>/`.
 *
 * The response body has no `id` field, but does have `charger_id` — `computedId`
 * derives a stable cache key from it.
 */
export const chargerActiveChargeSettingsCollection = createResourceCollection<
  ChargerActiveChargeSettings & { id: string }
>({
  name: 'chargerActiveChargeSettings',
  selector: (state) => state.chargerActiveChargeSettings,
  computedId: (data) =>
    `chargerActiveChargeSettings:charger_id:${data.charger_id}`,
  apiConfig: {
    path: 'active_charge_settings/charger',
  },
})

export default chargerActiveChargeSettingsCollection.slice.reducer
